import apiUrls from '../../youwell-common/apiUrls';
import ReduxStoreHelper, { LOGOUT } from '../../youwell-common/ReduxStoreHelper';
import { toLookup } from '../../youwell-common/arrayUtils';

const ACTION_PREFIX = 'PROGRAM';
const PROGRAM_RECIEVED = 'PROGRAM_RECIEVED';
const CONTENT_RECIEVED = 'CONTENT_RECIEVED';

const storeHelper = new ReduxStoreHelper(ACTION_PREFIX);

export const actionCreators = {
    getProgramDetails: storeHelper.createGetElementActionCreator(apiUrls.app.public, PROGRAM_RECIEVED),
    getPageContent: storeHelper.createGetElementActionCreator(apiUrls.app.public, CONTENT_RECIEVED),
};

const initialState = {
    ...storeHelper.defaultInitialState,
    programDetails: null,
    skillDetails: null,
    taskDetails: null,
    content: null,
};

export const reducer = (state, action) => {
    switch (action.type) {
    case LOGOUT: {
        return {
            ...initialState,
            content: { ...state.content },
        };
    }
    case `${ACTION_PREFIX}/${PROGRAM_RECIEVED}`: {
        return {
            ...state,
            programDetails: action.data,
            skillDetails: toLookup(action.data?.modules),
            taskDetails: action.data?.modules ? action.data.modules.reduce((prev, curr) => ({ ...prev, ...toLookup(curr.tasks) }), {}) : null,
        };
    }
    case `${ACTION_PREFIX}/${CONTENT_RECIEVED}`: {
        return {
            ...state,
            content: {
                ...state.content,
                [action.data.id]: action.data,
            },
        };
    }
    default: {
        const stateFromDefaultActions = storeHelper.defaultReducer(state, action, initialState);

        if (stateFromDefaultActions !== null) {
            return stateFromDefaultActions;
        }

        return state || initialState;
    }
    }
};
